import { ReactNode } from "react";

/**
 * Bordered section card with a dark header — matches the vendor-payouts page
 * styling. Used to group fields on the order-ahead create/edit forms.
 */
export function OrderAheadFormSection({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) {
  return (
    <div className="border border-gray-200 rounded-lg overflow-hidden bg-white mb-4">
      <div className="bg-gray-800 px-3 py-2">
        <h3 className="text-xs font-semibold text-white uppercase tracking-wide">
          {title}
        </h3>
      </div>
      <div className="p-4">{children}</div>
    </div>
  );
}
